/**
 * sophior-email-capture.js
 * Cookieloze e-mailcapture (P-22). Schrijft in op de Klaviyo-lijst via de
 * publieke client-API, precies zoals assets/sophior-klaviyo-form.js dat voor
 * de footer doet: alleen een lijst-ID en de publieke API-key, geen klaviyo.js,
 * geen cookie. Werkt daarmee ook vóór en zonder marketingtoestemming.
 *
 * Eén gedelegeerde listener op document, zodat het blok ook werkt wanneer de
 * cart drawer zijn lege staat pas ná het laden opnieuw in de DOM zet (bij een
 * her-render voert een geïnjecteerde <script>-tag niet uit).
 */
(function () {
  if (window.sophiorEmailCaptureReady) return;
  window.sophiorEmailCaptureReady = true;

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function getMessageEl(form) {
    var card = form.closest('[data-sophior-capture]');
    return card ? card.querySelector('[data-sophior-capture-msg]') : null;
  }

  function showMessage(msg, key) {
    if (!msg) return;
    // Eerst tonen, dan de tekst zetten: een verborgen live region kondigt niets
    // aan, dus de volgorde bepaalt of schermlezers de melding voorlezen.
    msg.hidden = false;
    msg.textContent = msg.dataset[key] || '';
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('[data-sophior-capture-form]')) return;

    event.preventDefault();

    var input = form.querySelector('input[type="email"]');
    var button = form.querySelector('button[type="submit"]');
    var honeypot = form.querySelector('[data-sophior-capture-hp]');
    var msg = getMessageEl(form);

    if (!input) return;

    // Honeypot gevuld: stilhouden, niets versturen.
    if (honeypot && honeypot.value) {
      form.hidden = true;
      showMessage(msg, 'success');
      return;
    }

    var email = (input.value || '').trim();
    if (!EMAIL_RE.test(email)) {
      input.setAttribute('aria-invalid', 'true');
      showMessage(msg, 'invalid');
      input.focus();
      return;
    }
    input.removeAttribute('aria-invalid');

    if (button) button.disabled = true;

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: form.dataset.source || 'Website inschrijfblok',
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email }
            }
          }
        },
        relationships: {
          list: {
            data: { type: 'list', id: form.dataset.klaviyoList }
          }
        }
      }
    };

    fetch(
      'https://a.klaviyo.com/client/subscriptions/?company_id=' +
        encodeURIComponent(form.dataset.klaviyoCompany),
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify(payload)
      }
    )
      .then(function (response) {
        if (!response.ok) throw new Error('Klaviyo subscribe failed: ' + response.status);
        form.hidden = true;
        showMessage(msg, 'success');
        // Signaal voor paginaspecifieke scripts (bijv. de early access-pagina:
        // bevestiging in alle formulieren en het aanmeld-event). Zonder
        // luisteraar gebeurt er niets.
        try {
          form.dispatchEvent(new CustomEvent('sophior:capture-success', { bubbles: true }));
        } catch (e) {
          /* oude browsers zonder CustomEvent: de melding staat er al */
        }
      })
      .catch(function () {
        if (button) button.disabled = false;
        showMessage(msg, 'error');
      });
  });
})();
